// src/main.jsx - Vite Entry Point
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Global styles
import './styles/global.css';

// Error boundary for production
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
    
    // In production, send to error tracking service
    // Example: Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '20px',
          fontFamily: 'Libre Franklin, sans-serif',
          background: '#F9FAFB'
        }}>
          <div style={{
            maxWidth: '500px',
            textAlign: 'center',
            padding: '40px',
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h1 style={{ 
              fontSize: '24px', 
              fontWeight: '700', 
              marginBottom: '12px',
              color: '#EF4444'
            }}>
              Something went wrong
            </h1>
            <p style={{ 
              fontSize: '14px', 
              color: '#6B7280',
              marginBottom: '24px',
              lineHeight: '1.6'
            }}>
              We're sorry, but something unexpected happened. Please try refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '12px 24px',
                background: '#0064A5',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer'
              }}
            >
              Reload Page
            </button>
            {import.meta.env.DEV && (
              <details style={{ 
                marginTop: '24px', 
                textAlign: 'left',
                fontSize: '12px',
                color: '#6B7280'
              }}>
                <summary style={{ cursor: 'pointer', fontWeight: '600' }}>
                  Error Details (Dev Mode)
                </summary>
                <pre style={{ 
                  marginTop: '12px', 
                  padding: '12px',
                  background: '#F9FAFB',
                  borderRadius: '6px',
                  overflow: 'auto',
                  maxHeight: '200px'
                }}>
                  {this.state.error?.toString()}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

// Mount the app
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

/*
 * VITE CONFIGURATION NOTES:
 * 
 * Environment Variables:
 * - Access with import.meta.env.VITE_*
 * - Example: import.meta.env.VITE_API_URL
 * 
 * Hot Module Replacement (HMR):
 * - Automatically enabled in dev mode
 * - Preserves component state during development
 * 
 * Build Optimization:
 * - Run `npm run build` for production
 * - Output goes to /dist folder
 * - Automatically code-splits and tree-shakes
 * 
 * Import Aliases (configure in vite.config.js):
 * - @/components → src/components
 * - @/utils → src/utils
 * - @/config → src/config
 */